<div class="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
  <div class="max-w-7xl mx-auto">
    <!-- Header -->
    <div class="d-flex mb-4">
      <div [innerHtml]="SVG_ICONS.BACK_BUTTON() | sanitizer : 'html'" (click)="onBack()" tabindex="0" (keyup.enter)="onBack()" class="cursor-pointer"></div>
      <div class="font-white fs-14 fw-bold mt-1 ms-2">Finance Details</div>
    </div>
    <div class="bg-slate-800 rounded-xl shadow-xl p-6 mb-6 border border-slate-700">
      <div class="flex items-start justify-between">
        <div class="flex items-center gap-4">
          <div>
            <h1 class="text-3xl font-bold text-white">{{ studentData?.FirstName }} {{ studentData?.MiddleName }} {{ studentData?.LastName }}</h1>

            <div class="flex items-center gap-4 mt-2 text-slate-300">
              <div class="flex items-center gap-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
                <span class="text-sm">Member ID: {{ studentData?.StudentID }}</span>
              </div>

              <div class="flex items-center gap-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                <span class="text-sm">{{ studentData?.center?.CenterName }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="text-right">
          <div class="text-sm text-slate-400">Mobile No</div>
          <div class="text-lg font-semibold text-slate-200">
            <a href="tel: +91 {{ studentData?.MobileNo }}" class="font-white fs-16 fw-bold text-decoration-none">+91 {{ studentData?.MobileNo }}</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Package Subscription -->
    <div class="bg-slate-800 rounded-xl shadow-xl p-6 mb-6 border border-slate-700">
      <div class="flex items-center gap-2 mb-4">
        <h2 class="text-xl font-bold text-white">Package Subscription</h2>
      </div>

      <div *ngFor="let sub of studentData?.packageSubscriptions" class="mt-2 bg-gradient-to-br from-slate-700 to-slate-800 rounded-lg p-6 border border-slate-600">
        <div class="flex justify-between items-start mb-4">
          <div>
            <h3 class="text-2xl font-bold text-white mb-1">
              {{ sub?.packageDetails?.PackageName }}
            </h3>

            <div class="flex items-center gap-2 text-slate-300">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
              <span class="text-sm">Started on {{ formatDate(sub?.CreatedDate) | date : "dd/MM/yyyy" }}</span>
            </div>
            <div class="flex items-center gap-2 text-slate-300">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
              <span class="text-sm">Ends on {{ formatDate(sub?.EndDate) | date : "dd/MM/yyyy" }}</span>
            </div>
          </div>

          <div class="text-right">
            <div class="text-3xl font-bold text-blue-400">
              {{ formatCurrency(sub?.TotalAmount) }}
            </div>
            <div class="text-sm text-slate-400">Total Amount</div>
          </div>
        </div>

        <div class="grid grid-cols-4 gap-4 mt-6 pt-6 border-t border-slate-600">
          <div class="bg-slate-800/70 rounded-lg p-4 border border-slate-600">
            <div class="text-sm text-slate-400 mb-1">Package Amount</div>
            <div class="text-lg font-semibold text-white">
              {{ formatCurrency(sub?.PackageAmount) }}
            </div>
          </div>

          <div class="bg-slate-800/70 rounded-lg p-4 border border-slate-600">
            <div class="text-sm text-slate-400 mb-1">CGST (2.5%)</div>
            <div class="text-lg font-semibold text-white">
              {{ formatCurrency(sub?.CGstTax) }}
            </div>
          </div>

          <div class="bg-slate-800/70 rounded-lg p-4 border border-slate-600">
            <div class="text-sm text-slate-400 mb-1">SGST (2.5%)</div>
            <div class="text-lg font-semibold text-white">
              {{ formatCurrency(sub?.SGstTax) }}
            </div>
          </div>

          <div class="bg-slate-800/70 rounded-lg p-4 border border-slate-600">
            <div class="text-sm text-slate-400 mb-1">Final Amount</div>
            <div class="text-lg font-semibold text-green-400">
              {{ formatCurrency(sub?.packageDetails?.FinalAmount) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Class Enrollments -->
    <div class="bg-slate-800 rounded-xl shadow-xl p-6 mb-6 border border-slate-700">
      <div class="flex items-center gap-2 mb-4">
        <h2 class="text-xl font-bold text-white">Class Enrollments</h2>
      </div>

      <div class="space-y-3">
        <div *ngFor="let enrollment of studentData?.classEnrollments" class="bg-slate-700/50 rounded-lg p-4 border border-slate-600 hover:shadow-lg hover:border-slate-500 transition-all">
          <div class="flex justify-between items-center">
            <div>
              <h3 class="font-semibold text-white text-lg">
                {{ enrollment?.classDetails?.ClassName }}
              </h3>
              <div class="text-sm text-slate-400">Class ID: {{ enrollment?.classDetails?.ClassID }}</div>
            </div>

            <div class="flex gap-2">
              <span *ngIf="enrollment?.IsPaymentDone" class="px-3 py-1 bg-green-500/20 text-green-400 rounded-full text-sm f-medium border border-green-500/30"> Paid </span>

              <span *ngIf="enrollment?.IsActive" class="px-3 py-1 bg-blue-500/20 text-blue-400 rounded-full text-sm font-medium border border-blue-500/30"> Active </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment Ledger -->
    <div class="bg-slate-800 rounded-xl shadow-xl p-6 border border-slate-700">
      <div class="flex items-center gap-2 mb-4">
        <h2 class="text-xl font-bold text-white">Payment Ledger</h2>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full">
          <thead>
            <tr class="border-b-2 border-slate-600">
              <th class="text-left py-3 px-4 text-sm font-semibold text-slate-300">Date</th>
              <th class="text-left py-3 px-4 text-sm font-semibold text-slate-300">Invoice Number</th>
              <th class="text-left py-3 px-4 text-sm font-semibold text-slate-300">Receipt Number</th>
              <th class="text-right py-3 px-4 text-sm font-semibold text-slate-300">Debit</th>
              <th class="text-right py-3 px-4 text-sm font-semibold text-slate-300">Credit</th>
              <th class="text-left py-3 px-4 text-sm font-semibold text-slate-300">Remarks</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let ledger of studentData?.PaymentLedger" class="border-b border-slate-700 hover:bg-slate-700/50 transition-colors">
              <td class="py-4 px-4 text-sm text-slate-300">
                {{ formatDate(ledger?.Date) | date : "dd/MM/yyyy" }}
              </td>

              <td class="py-4 px-4">
                <span class="text-sm font-mono bg-blue-500/20 text-blue-400 px-2 py-1 rounded border border-blue-500/30">
                  {{ ledger?.InvoiceNumber }}
                </span>
              </td>

              <td class="py-4 px-4">
                <span class="text-sm font-mono bg-green-500/20 text-green-400 px-2 py-1 rounded border border-green-500/30">
                  {{ ledger?.FinalReceiptNumber || "-" }}
                </span>
              </td>

              <td class="py-4 px-4 text-right text-sm font-semibold text-red-400">
                {{ ledger?.Debit > 0 ? formatCurrency(ledger?.Debit) : "-" }}
              </td>

              <td class="py-4 px-4 text-right text-sm font-semibold text-green-400">
                {{ ledger?.Credit > 0 ? formatCurrency(ledger?.Credit) : "-" }}
              </td>

              <td class="py-4 px-4 text-sm text-slate-400">
                {{ ledger?.Remarks }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Summary -->
      <div class="mt-6 pt-6 border-t-2 border-slate-600">
        <div class="flex justify-end">
          <div class="bg-gradient-to-br from-green-500/10 to-emerald-500/10 rounded-lg p-6 border-2 border-green-500/30">
            <div class="text-sm text-slate-400 mb-1">Total Payments Received</div>
            <div class="text-3xl font-bold text-green-400">
              {{ formatCurrency(totalPayments) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
